module.exports = __webpack_public_path__ + "static/img/btn_wallpaper005.3929361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_wallpaper005.svg
// module id = 85
// module chunks = 0